import { Select, Input, message } from 'antd';
import { FC, useEffect, useState } from 'react';
import { useGlobalContext } from './../../../../context/globalContext';
import { CheckSquareOutlined} from '@ant-design/icons'
interface captionEditProps {
  store: any;
  words: any;
  index: number;
  isActive: boolean;
  onIconClick: () => void;
}

const EditCaptions: FC<captionEditProps> = ({ store, words, index, isActive, onIconClick  }) => {
  const {
    ScriptDetails: [scriptDetails, setScriptDetails],
  } = useGlobalContext();
  const [oldConcatenatedString, setOldCConcatenatedString]=useState('')
  const [wordLength, setWordLength]=useState(0)
  const [newString, setNewString]=useState('')
  const [stringEdited, setStringEdited] = useState(false)
    const captionSave=async()=>{

    const newStringLength=newString.split(' ')
        // if(wordLength === newStringLength.length){
            const updatedWords = replaceWords(words, newStringLength);
            // console.log(updatedWords)
            await setScriptDetails((prevScript: { data: any }) => {
                const updatedScript = { ...prevScript }
                const updatedData = [...prevScript.data ? prevScript.data : prevScript]
                updatedData[index] = {
                  ...updatedData[index],
                  captions: words ? [{words:updatedWords, text:newString}] : [],
                }
                message.success("Captions updated!")
                onIconClick(); 
                return { ...updatedScript, data: updatedData }
              })
            setStringEdited(false)

           
        // } else{
        //     message.warning("Ensure that the length of the previous caption matches the length of the new caption.")
        //     setIconColor('var(--color-primary-600)');
        //   }
    }

    function replaceWords(words: any, replacements: any) {
        return words.map((wordObj:any, index:number) => ({
            ...wordObj,
            word: replacements[index]
        }));
    }
//   const concatenatedString = words.map((item: any) => item.word).join(' ');
useEffect(()=>{
    setOldCConcatenatedString(words.map((item: any) => item.word).join(' '))
    setNewString(words.map((item: any) => item.word).join(' '))
    setWordLength(words.length)
},[])
  return (
    <>
      <Label>Scene {index + 1}</Label>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'baseline',
        }}
      >
        <Input
          value={newString}
          placeholder='Edit captions'
          style={{
            width: '100%',
            marginRight: '10px',
          }}
          onChange={(e)=> {
            
            setNewString(e.target.value)
            setStringEdited(true)
          }}
        />

        <CheckSquareOutlined 
        style={{
          color: !stringEdited ? 'var(--color-gray-400)' : 'white',
          background: !stringEdited ? 'var(--color-gray-200)' : 'var(--color-primary-500)',
          cursor: !stringEdited ? 'not-allowed' : 'pointer',
          fontSize: '20px',
          outline: 'none',
          border: `1px solid ${!stringEdited ? 'var(--color-gray-400)' : 'var(--color-primary-600)'}`,
          opacity: !stringEdited ? 0.5 : 1 // Adds a disabled-like appearance
        }}
        
        onClick={()=>{
          
          if(stringEdited) captionSave()
        }}
        />
      </div>
    </>
  );
};

const Label = ({ children }: { children: React.ReactNode }) => {
  return (
    <h3
      style={{
        color: 'black',
        fontSize: '14px',
        fontWeight: 500,
        fontFamily: 'DM Sans',
        letterSpacing: 'normal',
        marginBottom: '10px',
      }}
    >
      {children}
    </h3>
  );
};
export default EditCaptions;
